<div class="card-header">
  <div class="card-title">
    <h3 class="card-label">Assign Device</h3>
  </div>
</div>
<mat-dialog-content
  class="navi-hover scroll card-body"
  [perfectScrollbar]="{ wheelPropagation: false }"
>
  <div style="padding: 20px 5px">
    <div class="example-container">
      <form [formGroup]="deviceInventoryForm">
        <kt-alert *ngIf="rangesRequierd" type="warn" [duration]="6000">
          please fill the patient ranges
        </kt-alert>

        <div style="width: 100%" class="kt-margin-bottom-10-mobile">
          <kt-general-autocomplete
            [label]="'Device'"
            [loadItemsFunction]="filterDevicesFn"
            [optionFormatter]="displayDevice"
            [valueFormatter]="displayDevice"
            [required]="true"
            [control]="device_id"
            [change]="selectDevice.bind(this)"
            [placeholder]="'Device'"
            #deviceAutocomplete
            (keyup)="changeDevice()"
          ></kt-general-autocomplete>
        </div>

        <div style="width: 100%" class="kt-margin-bottom-10-mobile">
          <kt-general-autocomplete
            [label]="'Inventory'"
            [loadItemsFunction]="filterInventoryFn"
            [optionFormatter]="displayInventory"
            [valueFormatter]="displayInventory"
            [required]="true"
            [readOnly]="readOnlyInventory"
            [control]="deviceInventoryForm.get('inventory_id')"
            [change]="selectInventory.bind(this)"
            [dataPath]="'data'"
            [placeholder]="'Device Inventory'"
            #inventoryAutocomplete
          ></kt-general-autocomplete>
        </div>

        <mat-form-field appearance="fill" style="width: 100%">
          <mat-label>Date Assigned</mat-label>
          <input
            matInput
            [matDatepicker]="dp3"
            formControlName="date_assigned"
            [disabled]="true"
            required
          />
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker>
          <mat-error *ngIf="date_assigned.invalid">{{ getErrorMessage(date_assigned) }}</mat-error>
        </mat-form-field>
      </form>

      <div style="margin-top: 10px">
        <a
          *ngIf="showRangeForm"
          style="cursor: pointer; color: #00aaff"
          (click)="openPatientRanges()"
          >Set Patient Ranges</a
        >
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 18px 36px">
  <div style="width: 100%; display: flex; justify-content: flex-end">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          mat-raised-button
          cdkFocusInitial
          matTooltip="Cancel"
          (click)="onCancelClick()"
        >
          Cancel</button
        >&nbsp;
        <button
          type="submit"
          mat-raised-button
          color="primary"
          matTooltip="Create"
          style="margin-right: 5px"
          (click)="onSubmit()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</mat-dialog-actions>
